// Import-free like tagEntityTypes: the tag cell renders from col-defs store/User reaches, so an import either way re-closes that cycle.
import { BehaviorSubject } from 'rxjs';

// A subject rather than a flag: a mounted tag cell has to re-arm when the role changes under it.
const canEditTagsSubject = new BehaviorSubject<boolean>(false);

export const setCanEditTags = (canEdit: boolean): void => canEditTagsSubject.next(canEdit);

export const getCanEditTags = (): boolean => canEditTagsSubject.getValue();

export const getCanEditTagsSubject = (): BehaviorSubject<boolean> => canEditTagsSubject;
